import axios from '@/utils/request'
var Qs = require('qs')

export default {
	in_type: ['init', 'check', 'allocate', 'rent', 'clean', 'salesProcess', 'returnBack', 'other'],
	out_type: ['check', 'allocate', 'damage', 'rent', 'clean', 'salesPrepared', 'salesProcess', 'other',],
	count_day: ['today', 'yesterday', 'week', 'lastweek', 'month', 'lastmonth'],

	// 2021-09-22
	search(params) {
		return axios.get('/weddingDressHall/stock-in-out', params)
	},
	// 2021-09-22
	findByInventoryId(inventoryId) {
		return axios.get('/weddingDressHall/stock-in-out/find-by-inventory-id/' + inventoryId)
	},
	// 2021-09-22
	batchIn(params) {
		return axios.post('/weddingDressHall/stock-in-out/batch-in', params)
	},
	// 2021-09-22
	batchOut(params) {
		return axios.post('/weddingDressHall/stock-in-out/batch-out', params)
	},
	// 2021-09-22
	count(params) {
		return axios.get('/weddingDressHall/stock-in-out/count', params)
	},
	// 2021-09-22
	exportExcel(params) {
		return axios.get('/weddingDressHall/stock-in-out/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},

}

